import Header from "@components/Account/Layout/Header/Header";
import { PROFILE_ROUTES } from "@components/Account/Layout/utils";
import LBox from "@components/LBox";
import LScreen from "@components/LScreen";
import LoadingCircle from "@components/LSuspense/LoadingCircle";

export const ProfileLoadingIndicator = ({
  fill = false,
}: {
  fill?: boolean;
}) => (
  <LBox
    accessibilityLabel="Loading profile"
    accessibilityRole="progressbar"
    alignItems="center"
    flex={fill ? 1 : undefined}
    flexDirection="row"
    justifyContent="center"
    minHeight={fill ? undefined : 240}
  >
    <LoadingCircle delay={0} />
    <LoadingCircle delay={333} />
    <LoadingCircle delay={666} />
  </LBox>
);

/**
 * Expo Router uses this while a child Profile route is suspended. Keep the
 * profile navigation visible instead of falling back to an empty tab scene.
 */
export const ProfileRouteLoadingFallback = () => (
  <LScreen
    enableAutomaticTopPadding
    paddingBottom="l3"
    paddingHorizontal="zero"
  >
    <LBox pb="s4" px="s4">
      <Header routes={PROFILE_ROUTES} />
    </LBox>
    <ProfileLoadingIndicator fill />
  </LScreen>
);
